module.exports = __webpack_public_path__ + "img/icon2(1).da177a0b.png";